var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBotUncheck({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13L11 17L19 9M7.4 25H18.6C20.8402 25 21.9603 25 22.816 24.564C23.5686 24.1805 24.1805 23.5686 24.564 22.816C25 21.9603 25 20.8402 25 18.6V7.4C25 5.15979 25 4.03969 24.564 3.18404C24.1805 2.43139 23.5686 1.81947 22.816 1.43597C21.9603 1 20.8402 1 18.6 1H7.4C5.15979 1 4.03969 1 3.18404 1.43597C2.43139 1.81947 1.81947 2.43139 1.43597 3.18404C1 4.03969 1 5.15979 1 7.4V18.6C1 20.8402 1 21.9603 1.43597 22.816C1.81947 23.5686 2.43139 24.1805 3.18404 24.564C4.03969 25 5.15979 25 7.4 25Z",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotUncheck);
export default __webpack_public_path__ + "static/media/bot_uncheck.76f7e44ad1a398255ae13ec073111aa4.svg";
export { ForwardRef as ReactComponent };